export default __webpack_public_path__ + "static/media/infeccion_urinaria.48f99807.pdf";